import { useState } from "react";
import { TCountryCode } from "@monorepo/helpers";

export type TSelectedPhoneCountryV2 = {
  countryCode: TCountryCode | "";
};

export const usePhone = () => {
  const [selectedPhoneCountry, setSelectedPhoneCountry] = useState<TSelectedPhoneCountryV2>({
    countryCode: "",
  });

  return { selectedPhoneCountry, setSelectedPhoneCountry };
};
